import React from 'react';

interface ClockIconProps {
  size?: number;
  color?: string;
}

export const ClockIcon: React.FC<ClockIconProps> = ({ 
  size = 32, 
  color = '#009951' 
}) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      fill="none" 
      viewBox="0 0 32 32"
    >
      <path 
        fill={color} 
        d="M16 3c7.18 0 13 5.82 13 13s-5.82 13-13 13S3 23.18 3 16 8.82 3 16 3m-.4 1.746.039.87q.242-.012.492-.012c5.677 0 10.275 4.651 10.275 10.396 0 5.744-4.598 10.397-10.275 10.397-4.282 0-7.95-2.646-9.493-6.413l1.32-.401-2.314-1.658-.91 2.635 1.077-.324c1.655 4.12 5.656 7.03 10.32 7.03 6.146 0 11.136-5.048 11.136-11.266S22.277 4.733 16.13 4.733q-.266 0-.53.013M9.11 21.92l10.371 2.683.21-.841-10.37-2.684zm4.426-12.53c-.186 1.258.134 2.67.679 3.83.306.649.679 1.22 1.047 1.636.2.227.401.4.583.526l-.26 1.025c-.219.02-.477.078-.764.179-.52.184-1.118.503-1.691.924-1.032.754-1.978 1.833-2.408 3.027l8.005 2.074c.186-1.257-.134-2.67-.68-3.83a7 7 0 0 0-1.046-1.634 3.3 3.3 0 0 0-.583-.527l.258-1.025c.215-.024.478-.077.764-.179.521-.184 1.12-.503 1.693-.924 1.032-.754 1.978-1.833 2.408-3.027zm-8.388 4.75A11.4 11.4 0 0 0 4.996 16v.044l.86-.01V16q.002-.878.141-1.722zm.815-2.738q-.383.869-.621 1.804l.836.203q.217-.855.57-1.653zm1.474-2.436a11.3 11.3 0 0 0-1.05 1.58l.749.426q.425-.777.968-1.465zm5.134-.725 10.37 2.683.21-.842-10.37-2.685zM9.46 6.981q-.755.572-1.403 1.264l.624.594c.396-.424.83-.814 1.29-1.164l-.23-.318zm2.475-1.418q-.889.368-1.692.876l.454.736a10 10 0 0 1 1.559-.806zm2.724-.731q-.95.128-1.844.41l.267.826a10 10 0 0 1 1.692-.375z"
      />
    </svg>
  );
};

